import type { BigFraction } from "@aprao/common/src/math/BigFraction.js";
import { FRACTION_ONE } from "@aprao/common/src/math/fraction.js";
import type { FundingType } from "@aprao/common/src/shapes/common.js";
import { makeAutoObservable } from "mobx";

import type { ShapeRevenueGroupBase } from "../../shapes/ShapeRevenueGroup.js";

export class RevenueGroupBaseFacade {
  $valueGrossScale = FRACTION_ONE;

  constructor(readonly $model: ShapeRevenueGroupBase) {
    makeAutoObservable(this);
  }

  get name() {
    return this.$model.name;
  }

  get fundingType() {
    return this.$model.fundingType;
  }

  get valueGrossScale() {
    return this.$valueGrossScale;
  }

  set name(name: string) {
    this.$model.name = name;
  }

  set fundingType(fundingType: FundingType) {
    this.$model.fundingType = fundingType;
  }

  /**
   * Tweaks the gross value with the given ratio.
   *
   * This is only used to generate the sensitivity analysis and is not
   * persisted into the model.
   */
  set valueGrossScale(ratio: BigFraction) {
    this.$valueGrossScale = ratio;
  }
}
